// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export class Constants {
    static readonly keys = {
        tab: "Tab",
        enter: "Enter",
        escape: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        delete: "Delete"
    } as const;
}
